var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReuploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F1A33A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9077_2853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.98837 9.70229H4.13123M4.13123 9.70229C4.13123 9.70229 5.67884 11.869 8.00027 11.869C10.1372 11.869 11.8693 10.3213 11.8693 8.46419M4.13123 9.70229V11.869M10.0122 6.29753H11.8693M11.8693 6.29753C11.8693 6.29753 10.3217 4.13086 8.00027 4.13086C5.86332 4.13086 4.13123 5.67848 4.13123 7.53562M11.8693 6.29753V4.13086",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9077_2853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.90476,
    height: 9.90476,
    fill: "white",
    transform: "translate(3.04785 3.04761)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReuploadIcon);
export default __webpack_public_path__ + "static/media/reupload-icon.8f73715d9ec4ef3296ef9f7643d82822.svg";
export { ForwardRef as ReactComponent };